export default function EmergencyProcedureDirective() {
  return {
    template: require('./emergency-procedure.html'),
    scope: {
      assessmentId: '=',
      procedure: '=',
    },
    controller: 'EmergencyProcedureController',
    controllerAs: 'emergencyProcedureVM',
    bindToController: true,
    replace: true,
  };
}
